export default {
  help_article_url:
    'https://help.thanx.com/hc/en-us/articles/38999199980951-How-to-Upload-Customer-Lists',
  self_serve_banner: {
    title: 'Customer list import is now fully self-serve',
    body: 'Thanx customer support will no longer take requests for manual list import. Now you can import lists and custom tags by importing a CSV.',
    learn_more: 'Learn more',
  },
  how_it_works: {
    title: 'HOW DOES IT WORK:',
    description:
      'Upload CSV files to add customers to your lists. Each list automatically becomes a segment for targeting.',
    step_1: 'Click Create a new list (or select an existing one)',
    step_2: 'Upload your CSV file',
    step_3: 'Map your columns to CRM fields',
  },
  landing: {
    title: 'Customer lists',
    description: 'Create and manage customer lists for targeted campaigns.',
    button: 'Create a new list',
    view: 'View',
    create_campaign: 'Create a campaign',
    create_campaign_error:
      'Something went wrong creating the campaign. Please try again.',
    import_customers: 'Import customers',
    rename: 'Rename',
    delete_list: 'Delete',
    search_placeholder: 'Search lists...',
    empty: {
      title: 'No customer lists yet',
      description:
        'Create your first list to start targeting specific customer groups.',
    },
    delete_modal: {
      title: 'Delete customer list',
      description:
        "Are you sure you want to delete '%{name}'? Customers will remain in your CRM but will no longer be associated with this list.",
      confirm: 'Delete',
      success: 'Customer list deleted successfully',
      error: 'Failed to delete customer list',
      blocked_title: "Can't delete '%{name}'",
      blocked_description:
        'This list cannot be deleted because it has active campaigns or content blocks targeting it. Please pause or remove them first.',
      blocked_campaigns_label: 'Active campaigns:',
      blocked_ok: 'OK',
    },
    rename_modal: {
      title: 'Rename customer list',
      confirm: 'Rename',
      success: 'Customer list renamed successfully',
      error: 'Failed to rename customer list',
      placeholder: 'Enter new name',
    },
  },
  import_row_limit: {
    note: 'Files can have up to %{limit} rows. Split larger files into several imports.',
  },
  import_mode_modal: {
    title: 'Update customer data',
    info_note: 'Imports may take up to 3 hours to fully process.',
    update_title: 'Update existing data',
    update_description:
      "New contacts in your file will be created in your CRM. If a contact already exists, we'll enrich their profile with any missing information without replacing existing data.",
    replace_title: 'Replace existing users in this list',
    replace_description:
      "We'll remove all current users from this list and replace them with users from this file. This won't delete customers from your CRM. Any automated campaigns using this list will continue to run and automatically apply to the updated audience.",
    cancel: 'Cancel',
    continue: 'Continue',
  },
  create_modal: {
    title: 'Create a new list',
    name_label: 'Customer list name',
    name_placeholder: 'Name your new list',
    cancel: 'Cancel',
    create: 'Create',
  },
  detail: {
    import_customers: 'Import customers',
    create_campaign: 'Create a campaign',
    create_campaign_error:
      'Something went wrong creating the campaign. Please try again.',
    tabs: {
      import_history: 'Import history',
      customers: 'Customers',
      active_campaigns: 'Active campaigns',
    },
  },
  import_history: {
    importing_banner: 'Importing %{fileName}...',
    empty: 'No imports yet.',
    download: 'Download',
    upload_label: 'Upload:',
    errors_label: 'Errors:',
    errors_csv_link_aria: 'Download errors CSV for %{filename}',
    status: {
      uploading: 'Uploading',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    status_tooltip: {
      intro: 'Please allow 1-3 hours for each import to fully process.',
      uploading: 'Uploading - File is being read (usually takes minutes)',
      processing:
        'Processing - Data is being validated and applied (1-2 hours)',
      completed: 'Completed - Import is ready for use',
    },
    columns: {
      file_name: 'File name',
      imported_by: 'Imported by',
      rows: 'Imported / Failed',
      date_uploaded: 'Date uploaded',
      status: 'Status',
    },
    importer: {
      error: 'Something went wrong with the import. Please try again.',
      importing: 'Importing customers...',
      success: 'Import completed successfully.',
      processing: 'Your import is being processed...',
    },
  },
  customers: {
    total_label: 'Total customers in this list',
    search_placeholder: 'Search customers by email, ID, or phone',
    view_profile: 'View profile',
    replication_notice:
      'Newly imported customers can take up to an hour to be fully available.',
    empty: 'No customers in this list yet.',
    anonymous: 'Thanx User',
    columns: {
      customer: 'Customer',
    },
  },
  campaigns: {
    empty: 'No active campaigns for this list.',
    columns: {
      name: 'Name',
      date_created: 'Date created',
      created_by: 'Created by',
      reward: 'Reward',
    },
    view: 'View',
  },
}
